import { z } from "zod";

export const Queue = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
});
export type Queue = z.infer<typeof Queue>;

export const QueueName = z.object({
  id: z.string(),
  name: z.string(),
});
export type QueueName = z.infer<typeof QueueName>;

export const QueueCreateInput = z.object({
  name: z.string().trim().min(3),
});
export type QueueCreateInput = z.infer<typeof QueueCreateInput>;

export const QueueCreateFromCaseInput = QueueCreateInput.extend({
  caseId: z.string(),
});
export type QueueCreateFromCaseInput = z.infer<typeof QueueCreateFromCaseInput>;

export const QueueByIdInput = z.object({ id: z.string() });
export type QueueByIdInput = z.infer<typeof QueueByIdInput>;

export const QueueUpdateInput = z.object({
  id: z.string(),
  name: z.string().trim().min(3).optional(),
});
export type QueueUpdateInput = z.infer<typeof QueueUpdateInput>;

export const SaveCasesAsQueueInput = z.object({
  queueName: z.string().trim().min(3),
  caseIds: z.array(z.string()),
});
export type SaveCasesAsQueueInput = z.infer<typeof SaveCasesAsQueueInput>;
